const CHENNAI_ROUTE_COPY = {
  Tirunelveli: {
    leaveHero:
      'Book a one-way taxi from Chennai to Tirunelveli, then edit pickup or drop if you need a more specific address.',
    returnHero:
      'Leave Tirunelveli for Chennai in a one-way cab. Pickup and drop are pre-filled for this inbound leg and stay editable.',
    leaveIntro: [
      'Chennai to Tirunelveli is a long southbound outstation taxi, often booked when you need to reach southern Tamil Nadu without keeping a cab for a same-day return. This page is only for that Chennai-origin leg.',
      'Pickup starts as Chennai. You can change it to Chennai Airport or another mapped point. Drop starts as Tirunelveli — the spelling used for this landing page — and can be narrowed to a house, hotel or junction before you estimate.',
      'There is no separate Tirunelveli package fare. After Get Fare Estimate, Sedan, SUV and Crysta show totals from the live mapped drive plus the published tariff and driver bata.',
    ],
    returnIntro: [
      'Tirunelveli to Chennai is the ride back toward the capital, not a copy of the outbound page. Book it when you are already in Tirunelveli and only need that northbound taxi.',
      'The form opens with Tirunelveli pickup and Chennai drop. Replace either field if you are leaving from a neighbourhood in Tirunelveli or finishing at a specific Chennai address or the airport.',
      'One Way stays selected so you are not holding a return vehicle in Chennai unless you switch the card to Round Trip.',
    ],
    leaveTravel:
      'You stay in one cab from your Chennai pickup through to Tirunelveli. The drive is mapped live for this direction rather than reused from another city’s catalogue.',
    returnTravel:
      'The return starts in Tirunelveli and continues to Chennai as its own mapped drive. This page does not copy the outbound kilometre or treat both directions as the same trip.',
    leaveMeta:
      'Book a one-way Chennai to Tirunelveli taxi with Easy Drop Taxi. Pickup starts in Chennai, drop in Tirunelveli, and the fare uses the live online estimate.',
    returnMeta:
      'Book a one-way Tirunelveli to Chennai taxi with Easy Drop Taxi. Pickup starts in Tirunelveli, drop in Chennai, and both fields stay editable in the existing form.',
    leaveFaqs: [
      {
        question: 'Can I start this Chennai to Tirunelveli taxi from the airport?',
        answer:
          'Yes. Change pickup to Chennai Airport or another airport address, keep Tirunelveli as drop or edit it, then continue with Get Fare Estimate.',
      },
      {
        question: 'Is Tirunelveli the same as Thirunelveli on other pages?',
        answer:
          'This pair uses the Tirunelveli spelling in the URL and booking defaults. If Google Places suggests Thirunelveli for your exact point, you can accept that suggestion in the field. It is still the same city booking, not a second unpublished route.',
      },
    ],
    returnFaqs: [
      {
        question: 'Can I finish this Tirunelveli to Chennai taxi at the airport?',
        answer:
          'Yes. Keep Tirunelveli as pickup or edit it, change drop to Chennai Airport if that is where you will alight, then estimate as usual.',
      },
      {
        question: 'Does this reverse page copy the outbound Chennai kilometre?',
        answer:
          'No. Tirunelveli to Chennai is mapped on its own when you search. The outbound Chennai to Tirunelveli page is a separate URL.',
      },
    ],
  },
  Kanyakumari: {
    leaveHero:
      'Travel one way from Chennai to Kanyakumari in an Easy Drop Taxi cab, with both locations editable before you search.',
    returnHero:
      'Start in Kanyakumari and book a one-way taxi to Chennai when you are ready to leave the coast.',
    leaveIntro: [
      'Chennai to Kanyakumari is the coastal end-of-state drop from the capital. Travellers typically want a single vehicle for the full run rather than changing at a bus stand, and a one-way booking so the cab is not held for a return they will not take.',
      'Pickup defaults to Chennai. Drop defaults to Kanyakumari. Type a more specific start or finish — a hotel, the beach area or another mapped point — if that is where you will actually board or alight.',
      'Sample figures on this page appear only after live mapping. They are not a Kanyakumari package and they are not taken from the Coimbatore–kaniyakumari catalogue page.',
    ],
    returnIntro: [
      'Kanyakumari to Chennai is for leaving the southern tip toward the capital. It is a separate landing page because the drive is mapped from Kanyakumari pickup, not copied from the outbound Chennai start.',
      'Keep or edit Kanyakumari as pickup and Chennai as drop. Airport drop in Chennai is a field edit, not a different booking system.',
      'Vehicle rates remain ₹15 / ₹20 / ₹22 per km plus driver bata. Confirm extras such as toll on the review screen.',
    ],
    leaveTravel:
      'The outbound taxi runs from Chennai to Kanyakumari as one booked vehicle. Distance and time on this page come from the live map for that pickup and drop.',
    returnTravel:
      'You board in Kanyakumari and continue to Chennai without reusing the outbound map. If mapping is unavailable, use Get Fare Estimate in the booking card.',
    leaveMeta:
      'Book a Chennai to Kanyakumari one-way taxi with Easy Drop Taxi. Use the online form for pickup, drop and a live fare estimate toward the southern coast.',
    returnMeta:
      'Book a Kanyakumari to Chennai one-way taxi. Reverse-route defaults are pre-filled for leaving the coast toward Chennai, and both locations remain editable.',
    leaveFaqs: [
      {
        question: 'Does this page use the Coimbatore to Kanyakumari taxi URL?',
        answer:
          'No. Coimbatore pairs use a different slug. This page is only Chennai to Kanyakumari. Open the Coimbatore landing if you are actually starting in Coimbatore.',
      },
      {
        question: 'Can I finish at a specific point in Kanyakumari?',
        answer:
          'Yes. Drop is a starting label. Type a hotel, junction or other mapped place before you estimate.',
      },
    ],
    returnFaqs: [
      {
        question: 'Can I start from a hotel in Kanyakumari rather than the town name?',
        answer:
          'Yes. Pickup defaults to Kanyakumari but you can type a hotel or another mapped point before you estimate.',
      },
      {
        question: 'Is this the same booking as Chennai to Kanyakumari?',
        answer:
          'No. This page is only the Kanyakumari to Chennai leg. Use the outbound URL when you are leaving Chennai.',
      },
    ],
  },
  Rameshwaram: {
    leaveHero:
      'Book a one-way Chennai to Rameshwaram taxi online, then edit pickup or drop if you have a precise address.',
    returnHero:
      'Leave Rameshwaram for Chennai in a one-way cab through the same Easy Drop Taxi booking form.',
    leaveIntro: [
      'Chennai to Rameshwaram is an east-coast pilgrimage and leisure drop. The taxi is booked as a mainland-to-island-side outstation trip in one vehicle. This page is not the Coimbatore to Rameshwaram pair.',
      'Pickup starts in Chennai. Drop starts as Rameshwaram. Change pickup to Chennai Airport if that is where you will wait. Change drop if you need a hotel or another mapped point after the Pamban approach.',
      'Fare still follows billed live kilometres, the published vehicle rate and driver bata. Toll and any extras stay as shown when you review.',
    ],
    returnIntro: [
      'Rameshwaram to Chennai is the return toward the capital after time on the island side. Book it when you only need that inbound taxi, not a round trip held from Chennai.',
      'The card opens on Rameshwaram pickup and Chennai drop. Both fields stay editable. One Way is the default because this page is the reverse leg.',
      'Live mapping for Rameshwaram to Chennai is loaded on this page independently. Do not treat the outbound Chennai kilometre as the return figure.',
    ],
    leaveTravel:
      'You leave Chennai and continue in the same taxi toward Rameshwaram. Travel time depends on the live mapped drive and traffic, not a catalogue hour.',
    returnTravel:
      'The inbound taxi starts in Rameshwaram and finishes in Chennai. Mapping for this reverse is separate from the Chennai-origin page.',
    leaveMeta:
      'Book a one-way Chennai to Rameshwaram taxi with Easy Drop Taxi. Pickup starts in Chennai, drop in Rameshwaram, and the fare uses the live mapped estimate.',
    returnMeta:
      'Book a Rameshwaram to Chennai one-way taxi with Easy Drop Taxi. Pickup starts in Rameshwaram, drop in Chennai, and both locations stay editable.',
    leaveFaqs: [
      {
        question: 'Is this the same page as Coimbatore to Rameshwaram?',
        answer:
          'No. That pair already exists on its own Coimbatore URL. Use this page only when pickup is Chennai (or a Chennai address you type).',
      },
      {
        question: 'Can I change drop after Rameshwaram if I need a nearby point?',
        answer:
          'Yes. The drop field accepts a more specific mapped place. Neighbourhood lists are not invented on this page.',
      },
    ],
    returnFaqs: [
      {
        question: 'Can I leave from a specific point in Rameshwaram?',
        answer:
          'Yes. Pickup is pre-filled as Rameshwaram and stays editable for a hotel or another mapped address.',
      },
      {
        question: 'Should I use the Chennai to Rameshwaram page for the return?',
        answer:
          'No. Book Rameshwaram to Chennai here. The outbound Chennai page is a different URL with a different pickup default.',
      },
    ],
  },
};

export const getChennaiRouteProfile = (place) => CHENNAI_ROUTE_COPY[place] || null;

export const CHENNAI_EXTRA_DESTINATIONS = ['Tirunelveli', 'Kanyakumari', 'Rameshwaram'];

export const CHENNAI_ROUTE_HUB = 'Chennai';
